import Indicador from ".."
import EditFields from "./components/EditFields"
import { ParamFields } from "./components/ParamFields"
import ReportSummary from "./reports/summary"
import apontamentoReport from "./reports/index"

export default class AH extends Indicador {
    static get fullName() {
        return "Aferição de Herbicida"
    }

    static get abbrev() {
        return "AH"
    }

    static get field() {
        return "ah"
    }

    static get multTipo() {
        return true
    }

    static paramFields(tipoIndicadorField = '') {
        return <ParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <EditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return apontamentoReport(this, visita)
    }

    async renderReportSummary(visita, tipoName) {
        return ReportSummary(this, visita, tipoName)
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0
        }

        apontamento.litrosPorMetro = ((f(apontamento.velocidade) * f(apontamento.espacamentoEntreBicos) * f(apontamento.vazao) / f(params.constante)) || '').toFixed(4)

        const total = apontamento.coletas.length
        let sumPesagem = 0
        // let qtdConforme = 0

        for (const coleta of apontamento.coletas) {
            if (coleta.pesagem) {
                let pesagem = f(coleta.pesagem)
                sumPesagem += pesagem

                if (pesagem >= f(params.intervaloMin) && pesagem <= f(params.intervaloMax)) {
                    // qtdConforme++
                }
            }
        }

        apontamento.media = sumPesagem / total;
        apontamento.media = apontamento.media.toFixed(4);

        // (média das coletas / litros por metro) * (Vazão L/ha)
        apontamento.afericao = (f(apontamento.media) / f(apontamento.litrosPorMetro)) * f(apontamento.vazao);
        apontamento.afericao = apontamento.afericao.toFixed(4);

        const rawConformidade = (apontamento.media / apontamento.litrosPorMetro) * 100;
        apontamento.acima = rawConformidade > f(params.intervaloMax) ? 1 : 0;
        apontamento.abaixo = rawConformidade < f(params.intervaloMin) ? 1 : 0;
        let conformidade = rawConformidade > 100 ? rawConformidade - 200 : rawConformidade;

        return Math.abs(conformidade).toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatus(conformidade, meta, 94.73, 100, 103.15)
    }

    static getResultStr(apontamento) {
        return 'Velocidade: ' + apontamento.velocidade
            + ', Vazão: ' + apontamento.vazao
            + ', Espaçamento entre Bicos: ' + apontamento.espacamentoEntreBicos
            + ', L/metro: ' + apontamento.litrosPorMetro
            + ', Média: ' + apontamento.media
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },
            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            { title: "Implemento", field: "implemento.nomeImplemento", width: 'auto' },

            {
                title: "Conf.(%)", field: "conformidade", width: 38, getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },
        ]
    }
}
